/* eslint-disable no-use-before-define */
import React from 'react'
import { Formik, } from 'formik'
import { Form } from './filters/form'
import { cleanObject, parseDate, isCusip, arrayFrom, subscribe, unsubscribe} from '../twd/twd'
import { ErrorBoundary } from './error-boundary'
import { useOrders } from './use-orders'


export const Filters = () => {
    const { filters, accountsRef, showFilters } = useOrders()

    const [formRef, setFormRef] = React.useState(null)

    React.useEffect(() => {
        if (!formRef || !showFilters) return
        formRef.validateForm()
    }, [formRef, showFilters])

    React.useEffect(() => {
        if (!formRef || !showFilters) return

        let subId = subscribe('orders_accounts_changed.orders_filters', () => {
            formRef.validateForm()
        })
        return () => {
            unsubscribe(subId)
        }
    }, [formRef, showFilters])

    return <ErrorBoundary>
    <Formik
        ref={setFormRef}
        initialValues={{
            ...filters,
        }}
        enableReinitialize={true}

        component={Form}
        validate={(values) => {
            let errors = {}

            if (arrayFrom(accountsRef.state.values.accounts).length===0) {
                errors.accounts = "select one or more account"
            }

            const now = new Date()
            const minDt = parseDate(values.tradeSubmitDateRangeMin)
            const maxDt = parseDate(values.tradeSubmitDateRangeMax, true)

            if (!minDt) {
                errors.tradeSubmitDateRangeMin = "Please enter date"
            }
            if (!maxDt) {
                errors.tradeSubmitDateRangeMax = "3 year max date range"
            }
            if (minDt && maxDt) {
                if (minDt > now) {
                    errors.tradeSubmitDateRangeMin = "Please enter later date"
                }
                if (maxDt > now) {
                    errors.tradeSubmitDateRangeMax = "Please enter earlier date"
                }

                if (maxDt < minDt) {
                    errors.tradeSubmitDateRangeMax = "Please enter later date"
                }
                else if (maxDt > minDt) {
                    const nextDt = new Date(minDt.getFullYear()+3, minDt.getMonth(), minDt.getDate())
                    if (maxDt > nextDt) {
                        errors.tradeSubmitDateRangeMax = "3 year max date range"
                    }
                }
            }

            if (values.holdCusip &&
                values.holdCusip.split(',')
                    .filter(Boolean).map(a => a.trim()).filter(Boolean)
                    .findIndex(a => {
                        const n = a.length
                        return n<5 || n>9 || (n===9 && !isCusip(a))
                    })>= 0
            ) {
                errors.holdCusip = "Invalid cusip"
            }

            errors = cleanObject(errors)
            errors.length = Object.keys(errors).length
            return errors
        }}

        validateOnBlur={true}
        validateOnChange={true}
    />
    </ErrorBoundary>
}



// WEBPACK FOOTER //
// ./src/orders/filters.js